import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';

import {parameterStoreService} from '@/services/parameterStoreService';
import {getResponseMessage} from '@/utils/errorMessage';

export default function useParameterStore() {
  const [parameters, setParameters] = useState<Record<string, string>>({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await parameterStoreService.getParameters();
      setParameters(response);
    } catch (error) {
      console.error(error);
      toast.error(
        getResponseMessage(error) || 'An Error occured while fetching params',
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Fire-and-forget: fetchData catches and toasts its own failures, so this
    // only stops an unexpected throw becoming an unhandled rejection.
    fetchData().catch(() => {});
  }, []);

  return {
    parameters,
    isLoading,
  };
}
